<template>
  <div id="customer">
    <el-row>
      <el-button id="addBtn" type="primary" @click="toAddCustomer">新增角色</el-button>
    </el-row>

    <el-form id="queryForm" :inline="true" :model="queryForm" class="demo-form-inline">
      <el-form-item label="角色名称">
        <el-input v-model="queryForm.roleName" placeholder="角色名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query" icon="el-icon-search">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData.slice((queryForm.pageNum-1)*queryForm.pageSize,queryForm.pageNum*queryForm.pageSize)"
      style="width: 100%"
      :default-sort="{prop: 'date', order: 'descending'}"
      border
    >
      <el-table-column prop="roleName" label="角色名称"></el-table-column>
      <el-table-column prop="role" label="表达式" sortable></el-table-column>
      <el-table-column prop="description" label="描述"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit"></el-button>
          <el-button
            size="mini"
            type="danger"
            @click="removeCustomer(scope.row)"
            icon="el-icon-delete"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="changePage"
      @size-change="changeSize"
      :current-page.sync="queryForm.pageNum"
      :page-sizes="[10,20,30,40,50]"
      :page-size="queryForm.pageSize"
      :total="tableData.length"
      layout="total,sizes, prev, pager, next"
    ></el-pagination>

    <el-dialog title="添加角色" :visible.sync="dialogFormVisible" :width="dialogWidth">
      <el-tabs type="border-card">
        <el-tab-pane label="角色基本信息">
          <el-form :model="form">
            <el-form-item label="角色名称" :label-width="formLabelWidth">
              <el-input v-model="form.roleName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="表达式" :label-width="formLabelWidth">
              <el-input v-model="form.role" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="描述" :label-width="formLabelWidth">
              <el-input v-model="form.description" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="角色权限">
          <PermissionTree ref="tree" :default-tree="tree"/>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveCustomer">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="updateForm.roleName" :visible.sync="updateFormVisible" :width="dialogWidth">
      <el-tabs type="border-card">
        <el-tab-pane label="角色基本信息">
          <el-form :model="updateForm">
            <el-form-item label="角色名称" :label-width="formLabelWidth">
              <el-input v-model="updateForm.roleName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="表达式" :label-width="formLabelWidth">
              <el-input v-model="updateForm.role" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="描述" :label-width="formLabelWidth">
              <el-input v-model="updateForm.description" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="角色权限">
          <PermissionTree ref="tree1" :default-tree="tree"/>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateCustomer">更 新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PermissionTree from "@/components/system/PermissionTree.vue";
export default {
  components: {
    PermissionTree
  },
  data() {
    return {
      tableData: [],
      updateFormVisible: false,
      dialogFormVisible: false,
      form: {},
      updateForm: {},
      formLabelWidth: "120px",
      dialogWidth: "600px",
      queryForm: { pageNum: 1, pageSize: 10 },
      tree: [],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  methods: {
    formatter(row) {
      return row.address;
    },
    toAddCustomer() {
      // this.$router.push("/customer/add");
      this.dialogFormVisible = true;
    },
    query() {
      var self = this;
      this.$axios
        .get("system/role/query", { params: self.queryForm })
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.tableData = response.data.data;
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    saveCustomer() {
      //获取选中节点权限key
      if (this.$refs.tree) {
        var permissions = this.$refs.tree.getChecked();
        this.form.permissions = permissions;
      }
      var self = this;
      this.$axios.post("system/role/save", self.form).then(function(response) {
        if (response.data.errorCode == "00000") {
          self.dialogFormVisible = false;
          //清空表单
          self.form = {};
          self.$message({
            message: "保存成功",
            type: "success"
          });
          self.query();
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    removeCustomer(row) {
      var self = this;

      this.$confirm("此操作将永久删除该条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .delete("system/role/remove/" + row.id)
            .then(function(response) {
              if (response.data.errorCode == "00000") {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                self.query();
              } else {
                self.$message.error(response.data.errorMsg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleEdit(index, row) {
      console.log(JSON.stringify(row));
      this.updateForm = JSON.parse(JSON.stringify(row));
      this.updateFormVisible = true;
      var self = this;
      this.$axios
        .get("system/role/permission?roleId=" + row.id)
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.$nextTick(() => {
              self.$refs.tree1.setChecked(response.data.data);
            });
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    updateCustomer() {
      this.updateForm.permissions = this.$refs.tree1.getChecked();
      var self = this;
      this.$axios
        .post("system/role/update", self.updateForm)
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.updateFormVisible = false;
            self.$message({
              message: "更新成功",
              type: "success"
            });
            self.query();
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    changePage(pageNum) {
      this.queryForm.pageNum = pageNum;
    },
    changeSize(pageSize) {
      this.queryForm.pageSize = pageSize;
    }
  },
  created: function() {
    this.query();
    var self = this;
    this.$axios.get("system/permission/tree").then(function(response) {
        if (response.data.errorCode == "00000") {
          self.tree = response.data.data;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
  }
};
</script>

<style scoped>
#addBtn {
  float: right;
}
#queryForm {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>